import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import madeInFranceImage from "../../../assets/smartbuilding/MadeInFrance.jpg";
import OfficeInside from "../../../assets/smartbuilding/OfficeInside.jpg";
import MockupIphone from "../../../assets/smartbuilding/Mockup_iphone.png";

export default function KeepControl(props) {
  const { textContent, language } = { ...props };

  const screenWidth = useSelector((state) => state.screen.screenWidth);
  const isMobile = useSelector((state) => state.screen.isMobile);

  return (
    <section className="container">
      {!isMobile ? (
        <div className="keep-control">
          <div className="keep-control-image iphone">
            <img src={MockupIphone} alt="" />
          </div>
          <div className="keep-control-text">
            <h1 className="title-gradient madeInFrance-text-container">
              {textContent.keepControl.title[language]}
            </h1>
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html:
                  textContent.keepControl.description.description1[language],
              }}
            />
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html:
                  textContent.keepControl.description.description2[language],
              }}
            />
          </div>
          <div className="keep-control-image office">
            <img src={OfficeInside} alt="" />
          </div>
        </div>
      ) : (
        <div className="keep-control-mobile">
          <div className="keep-control-text-mobile">
            <h1 className="title-gradient madeInFrance-text-container">
              {textContent.keepControl.title[language]}
            </h1>

            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html:
                  textContent.keepControl.description.description1[language],
              }}
            />
            <p
              className="features-text"
              dangerouslySetInnerHTML={{
                __html:
                  textContent.keepControl.description.description2[language],
              }}
            />
          </div>
          <div className="keep-control-images-mobile">
            <div className="keep-control-image-mobile iphone">
              <img src={MockupIphone} alt="" />
            </div>

            <div className="keep-control-image-mobile office">
              <img src={OfficeInside} alt="" />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
